import { render, staticRenderFns } from "./ProductoView.vue?vue&type=template&id=924f0f22"
import script from "./ProductoView.vue?vue&type=script&lang=js"
export * from "./ProductoView.vue?vue&type=script&lang=js"
import style0 from "./ProductoView.vue?vue&type=style&index=0&id=924f0f22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports